import React from "react";
import useGlobalHook from "use-global-hook";
import * as actions from "../Actions/VoucherActions";

const initialState = {
  status: 200,
  isLoading: false,
  message: "",
  header: {},
  data: [],
  dataProperty: [],
  lastPage: false,
};

const VoucherStore = useGlobalHook(React, initialState, actions);

export default VoucherStore;
